import * as actionTypes from "../types/customersActionTypes";
import customersState from "./customersState";
import { ActionTypes } from "../types/customersActionTypes";

const initialState: customersState = {
    customers: [],
    loading: false,
    error: null
};

const customersReducer = (state = initialState, action: ActionTypes) => {
    switch (action.type) {
        case actionTypes.FETCH_CUSTOMERS_REQUEST:
            return {
                ...state,
                loading: true
            };

        case actionTypes.FETCH_CUSTOMERS_SUCCESS:
            return {
                ...state,
                loading: false,
                customers: action.payload
            };

        case actionTypes.FETCH_CUSTOMERS_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case actionTypes.ADD_CUSTOMER_REQUEST:
            return {
                ...state
            };

        case actionTypes.ADD_CUSTOMER_SUCCESS:
            return {
                ...state
            };

        case actionTypes.ADD_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case actionTypes.DELETE_CUSTOMER_REQUEST:
            return {
                ...state
            };

        case actionTypes.DELETE_CUSTOMER_SUCCESS:
            return {
                ...state
            };

        case actionTypes.DELETE_CUSTOMER_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default customersReducer;